import type Decimal from 'decimal.js';

/* eslint-disable camelcase */
export enum FeatureGroupEnum {
  basic,
  plus,
  business,
  scale,
}

export type FeatureGroup = keyof typeof FeatureGroupEnum;

export interface PlanDTO {
  feature_group: FeatureGroup;
  identifier: string;
  sample_rate: number;
  cc_daily_allowance: number;
}

export interface Plan {
  featureGroup: FeatureGroup;
  identifier: string;
  sampleRate: number;
  ccDailyAllowance: number;
}

export type PlanPriceTuple = [Plan, Decimal];

export type PlanPriceTuples = Array<PlanPriceTuple>;
